import styled from 'styled-components';

export const StyledIntegrationList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;